import React from 'react';
import './Styles/Join.scss';
import StyledButton from '../../Shared/StyledButton/StyledButton';
const Join=()=>{
    return(
        <div className="join-c">
            <h1>Join over 2 million people collaborating with HostDesign. Get started for free.</h1>
            <div className="selects">
            <StyledButton btn="Signup" styles="nobg-btn"/>
            <StyledButton btn="Explore Plans" styles="transparent-btn"/>
            </div>
        </div>
    )
};
export default Join;